module.exports = __webpack_public_path__ + "img/sustainability.f67c9fef.jpg";